module.exports = __webpack_public_path__ + "components/hindcast-prompt/static/icon__arrow-head-67fcab4dc7d56e1d7ed92e52c96c2db8.svg";